import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { IBordTableAction } from 'types/tableWithActions.types';
import NudosGenericSelect from 'components/NudosComponents/NudosGenericSelect';
import NudosSelectButton from 'components/NudosComponents/NudosSelectButton/NudosSelectButton';
import { useState } from 'react';
import './BordTableAction.scss';

const BordTableAction = ({ icon, text, action, options, enabled }: IBordTableAction) => {
  const [showGenericSelect, setShowGenericSelect] = useState(false);

  const selectOptions = options?.map(option => (
    <div className="bordTableActionOption" key={`option-${option.name}`}>
      <p>{option.name}</p>
      <NudosSelectButton
        handleClickButton={() => action && option?.value && action(+option?.value)}
        isButtonActive={option?.isActive}
      />
    </div>
  ));

  return (
    <div className="bordTableAction">
      {text && <p className="actionText">{text}</p>}
      <button onClick={() => setShowGenericSelect(!showGenericSelect)} className="action-button">
        {icon && (
          <BordOneToneIcon
            variant={icon}
            className="bordTableActionIcon"
            customWidth="14px"
            standardSize={20}
            stroke="#070F21"
          />
        )}
      </button>
      {enabled && showGenericSelect && (
        <NudosGenericSelect
          changeSelectedOption={action || (() => {})}
          selectOptions={selectOptions || []}
          defaultValue={undefined}
          selectClassName="bordTableActionSelect"
        />
      )}
    </div>
  );
};

export default BordTableAction;
